module.exports = __webpack_public_path__ + "static/media/Nokia 220 Red.79d2068c.png";